import {Component} from "../../../gvf/js/component";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class WebModal extends Component {
    static scope = ".js-web-modal";

    close() {
        this.$root.removeClass("is-open");
        this.$root.on("transitionend", () => {
            this.$root.remove();
        });
    }

    ready() {
        this.findMember("close").on("click", () => this.close());
        this.findMember("backdrop").on("click", () => this.close());
        $(document).on("keydown.web-modal", (ev) => {
            if (ev.key === "Escape") {
                this.close();
                $(document).off("keydown.web-modal");
            }
        });
        // trigger open transition on next frame
        requestAnimationFrame(() => this.$root.addClass("is-open"));
    }
}

GvfUiService.registerComponent(WebModal.scope, WebModal);

/**
 * Opens a URL inside a web-modal iframe.
 * @param {string} url
 */
export function openWebModal(url) {
    const $modal = $(`
        <div class="js-web-modal web-modal">
            <div class="js-web-modal__backdrop web-modal__backdrop"></div>
            <div class="web-modal__dialog web-modal__dialog--loading">
                <button class="js-web-modal__close web-modal__close" type="button" aria-label="Cerrar"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg></button>
                <div class="web-modal__loader"><div class="web-modal__spinner"></div></div>
                <iframe class="web-modal__iframe" src="${url}"></iframe>
            </div>
        </div>
    `);
    $modal.find(".web-modal__iframe").on("load", () => {
        $modal.find(".web-modal__dialog").removeClass("web-modal__dialog--loading");
    });
    $("body").append($modal);
    GvfUiService.init($modal);
}
